import React from "react";

function OpenLinkIcon({ color, viewBox = "0 0 20 20", className = "" }) {
  return (
    <svg data-testid="open-link-icon" xmlns="http://www.w3.org/2000/svg" viewBox={viewBox} className={className} width="24" height="24" fill="none">
      <path
        stroke={color || "currentColor"}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15.208 4.792l-5.555 5.555M10.348 4.792h4.86v4.86M13.125 11.042v3.125a1.041 1.041 0 01-1.042 1.041h-6.25a1.041 1.041 0 01-1.041-1.041v-6.25a1.042 1.042 0 011.041-1.042h3.125"
      ></path>
    </svg>
  );
}

export default OpenLinkIcon;
